import instance from "../config";

// Paso 1: usuario y contraseña -> el backend envía un código al correo.
// acceso: "superadmin" desde el login privado del superadmin
export const getLogin = (username, password, acceso) => {
  return instance.post("/auth/login", { username, password, acceso });
};

// Paso 2: código recibido por correo -> token de sesión
export const verificarCodigo = (tokenTemporal, codigo) => {
  return instance.post("/auth/verificar-codigo", { tokenTemporal, codigo });
};

// Datos de la sesión actual según el backend -> { username, uid, rol }
export const obtenerSesionActual = async () => {
  const { data } = await instance.get("/auth/protected");
  return data;
};

export const reenviarCodigo = (tokenTemporal) => {
  return instance.post("/auth/reenviar-codigo", { tokenTemporal });
};

// Cambio de la propia contraseña desde el perfil -> { msg }
export const cambiarPassword = async ({ passwordActual, passwordNueva, confirmarPassword }) => {
  const { data } = await instance.put("/auth/password", { passwordActual, passwordNueva, confirmarPassword });
  return data;
};
